export const SET_CONDITION = 'SET_CONDITION';
export const SET_CONDITIONS = 'SET_CONDITIONS';
export const SET_CONDITIONS_QUERY_PARAMS = 'SET_CONDITIONS_QUERY_PARAMS';
export const SET_CONDITIONS_SET_IS_FETCHING = 'SET_CONDITIONS_SET_IS_FETCHING';

export const SET_DICTCONDITION = 'SET_DICTCONDITION';
export const SET_DICTCONDITIONS = 'SET_DICTCONDITIONS';
export const SET_DICTCONDITIONS_QUERY_PARAMS = 'SET_DICTCONDITIONS_QUERY_PARAMS';
export const SET_DICTCONDITIONS_SET_IS_FETCHING = 'SET_DICTCONDITIONS_SET_IS_FETCHING';
